import type { UserProfile } from '../Module/User/Domain/entity/UserTypes';
import { isIndividualUserType } from './userType';

/** 나의 계정 URL `?tab=` 값 — 결제 정보 vs 본인 확인 서류 */
export type MissingSettlementDocsTabTarget = 'bank' | 'verification';

/**
 * 정산 서류 누락 안내 모달에서 "등록하기" 클릭 시 이동할 탭.
 * - 통장만 없음 → bank
 * - 신분증(등록 카드)만 없음 → verification
 * - 둘 다 없음 → 우선 통장 업로드 탭(bank)
 */
export function getMissingSettlementRegisterTabTarget(profile: UserProfile): MissingSettlementDocsTabTarget {
  const loc = profile.bank_location_country_code;
  const isKorea = loc === 'KR' || String(loc ?? '').trim().length === 0;
  const hasBankInfo = Boolean(profile.bank_account || profile.bank_name);
  if (!isKorea || !hasBankInfo) return 'bank';

  const missingBankbook = !String(profile.bankbook_image_url ?? '').trim();
  const missingId = !String(profile.registration_card_url ?? '').trim();
  const isIndividual = isIndividualUserType(profile.user_type);
  const isOrganizationWithoutUniqueId =
    !isIndividual && !String(profile.business_registration ?? '').trim();
  const needsId = isIndividual || !isOrganizationWithoutUniqueId;

  const idGap = needsId && missingId;

  if (!missingBankbook && idGap) return 'verification';
  return 'bank';
}
